export const DateService = {
  formatCalendarDate(data) {
    let dayValueFormat = data

    const year = dayValueFormat.slice(0, 4)
    const month = dayValueFormat.slice(5, 7)
    const day = dayValueFormat.slice(8, 11)
    dayValueFormat = `${year}-${month}-${day}T00:00:00`
    

    return dayValueFormat
  },
  formatDateAndTime(moment, time, utcOffset=true) {
    if (!time || time === '0000-00-00 00:00:00') {
      return 'N/A';
    }
    let lTime = moment(time).format('D MMM YYYY HH:mm');

    if (utcOffset) {
      lTime += " " + getUTCOffet(moment, time);
    }

    return checkError(lTime);
  },
  formatDateAndTimeUTC(moment, time) {
    if (!time || time === '0000-00-00 00:00:00') {
      return 'N/A';
    }
    let lTime = moment.utc(time).format('D MMM YYYY HH:mm [UTC]');

    return checkError(lTime);
  },
  formatDateOnly(moment, time) {
    if (!time || time === '0000-00-00 00:00:00') {
      return 'N/A';
    }
    const lTime = moment(time).format('D MMM YYYY');

    return checkError(lTime);
  }
}

/* Returns a string depending on the value of the UTC offset in minutes:
- if offset is 0: returns "UTC".
- if offset is a multiple of 60: "UTC+1", "UTC+2", "UTC-1", "UTC-2".
- else: "+01:30", "-00:45" */
function getUTCOffet(moment, my_date) {
  const offset = moment(my_date).utcOffset();
  if ((offset % 60) === 0) {
    if (offset === 0) {
      return "UTC";
    } else if (offset > 0) {
      return "UTC+" + (offset / 60);
    } else {
      return "UTC-" + (-offset / 60);
    }
  } else {
    return moment(my_date).format('Z');
  }
}

function checkError(time) {
  if (time.includes('Invalid')) {
    return 'N/A'
  }
  return time;
}
